module.exports = __webpack_public_path__ + "1c5a03f99ff2d7302cab5e50df7a6db0.png";